module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": "Settings",
      "subtitle": "Configure how you study"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "sm-p-30 xs-pt-30 xs-pb-30 xs-pl-10 xs-pr-10"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-form-label",
    attrs: {
      "for": "OrderMicronotesBy"
    }
  }, [_vm._v("Order micro notes by")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6"
  }, [_vm._c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedMicroNoteOrder),
      expression: "selectedMicroNoteOrder"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "OrderMicronotesBy"
    },
    on: {
      "change": function($event) {
        _vm.selectedMicroNoteOrder = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.microNoteOrderOptions), function(option) {
    return _vm._c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                      ")])
  }))])]), _vm._v(" "), _vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-form-label",
    attrs: {
      "for": "AllowSharing"
    }
  }, [_vm._v("Allow sharing")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6"
  }, [_vm._c('div', {
    staticClass: "pull-left"
  }, [_vm._c('BoolSwitch', {
    attrs: {
      "toggle-bool": _vm.AllowSharing,
      "toggle-function": _vm.toggleSharing,
      "on-text": "On",
      "off-text": "Off"
    }
  })], 1)])]), _vm._v(" "), _vm._c('div', {
    staticClass: "setting form-group row form-group-sm"
  }, [_vm._c('label', {
    staticClass: "col-xs-6 col-form-label",
    attrs: {
      "for": "AllowSharing"
    }
  }, [_vm._v("Receive system notifications")]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-6"
  }, [_vm._c('div', {
    staticClass: "pull-left"
  }, [_vm._c('BoolSwitch', {
    staticClass: "pull-left",
    attrs: {
      "toggle-bool": _vm.notifications,
      "toggle-function": _vm.toggleNotifications,
      "on-text": "On",
      "off-text": "Off"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (!_vm.notifications) ? _vm._c('div', {
    staticClass: "text-danger xs-mt-10"
  }, [_vm._v("Warning: You will not receive any system emails (shared lecture notes, blog comments, etc.)")]) : _vm._e()], 1)])])])]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 col-md-6 text-right"
  }, [_vm._c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("Save")])])])])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ed7fa5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/settings.vue
// module id = 680
// module chunks = 1